import {
  Animated,
  Easing,
  Modal,
  Platform,
  Pressable,
  SafeAreaView,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { CommonSetting } from "../../../components/setting/CommonSetting";
import BaseScreen from "../../BaseScreen";
import React, { useEffect, useRef, useState } from "react";
import { white } from "../../../assets/style/colors";
import * as ImSdk from "../../../../imsdk/api";
import { postJson } from "../../../net/http";
import { useChatStore } from "../../../store/ChatStore";
import { MainNavProps } from "../../navigation/main/MainParamList";
import {
  Str_AddAdmin,
  Str_AllProhibition,
  Str_AllProhibitionTip,
  Str_FriendInviteEnter,
  Str_GroupChatIntervalTime,
  Str_GroupDisbanded,
  Str_GroupEntryReview,
  Str_GroupManagement,
  Str_MemberJoinGroupMessage,
  Str_MemberLeaveGroupMessage,
  Str_MemberModifyGroupNickname,
  Str_MemberSendDocument,
  Str_MemberSendImage,
  Str_MemberSendVideo,
  Str_OpenUser,
  Str_Prohibition,
  Str_RemoveAdmin,
  Str_RemoveProhibition,
  Str_Second,
  Str_SetFontStyle,
  Str_TransferGroup,
} from "../../../language/string_res";
import { showToast } from "../../../components/Toast";
import { hideLoading, showLoading } from "../../../components/Loading";
import { use } from "i18next";

type GroupManagerState = {
  joinGroup: boolean;
  lookGroupList: boolean;
  openUser: boolean;
  friendInviteEnter: boolean;
  jinYan: boolean;
  memberSetAlias: boolean;
  memberSetImage: boolean;
  memberSetVideo: boolean;
  memberSetQuitMsg: boolean;
  memberSetJoinMsg: boolean;
  memberSetDocument: boolean;
};

interface GroupManagerModalProps {
  visible: boolean;
  onClose: () => void;
  navigation: any;
}

export const GroupManagerModal = ({ 
  visible, 
  onClose,
  navigation,
}: GroupManagerModalProps) => {
  const im = ImSdk.getInstance();
  const currentUid = im.CurrentUid();
  const { chatState, chatDispatch } = useChatStore();
  const group = chatState.curTopicWithSummary.group;
  const topic = chatState.curTopicWithSummary.topic;
  const slideAnim = useRef(new Animated.Value(0)).current;

  const updateGroupLocal = (patch: Record<string, any>) => {
    const cur = chatState.curTopicWithSummary;
    if (!cur?.group) return;
    chatDispatch({
      type: "CHAT_GROUP_UPDATE",
      payload: {
        group: { ...cur.group, ...patch } as any,
      },
    });
  };

  const [state, setState] = useState<GroupManagerState>({
    joinGroup: group?.group_check_switch === "1",
    lookGroupList: group?.group_allow_member_list === "1",
    openUser: group?.group_allow_member_visit === "1",
    friendInviteEnter: group?.group_friend_invite_enter === "1",
    jinYan: group?.group_ban_chat === "1",
    memberSetAlias: group?.group_member_alias === "1",
    memberSetImage: group?.group_member_image === "1",
    memberSetVideo: group?.group_member_video === "1",
    memberSetDocument: group?.group_member_doc === "1",
    memberSetQuitMsg: group?.group_member_quit_msg === "1",
    memberSetJoinMsg: group?.join_notice === 1,
  });

  useEffect(() => {
    if (!visible) return;
    setState({
      joinGroup: group?.group_check_switch === "1",
      lookGroupList: group?.group_allow_member_list === "1",
      openUser: group?.group_allow_member_visit === "1",
      friendInviteEnter: group?.group_friend_invite_enter === "1",
      jinYan: group?.group_ban_chat === "1",
      memberSetAlias: group?.group_member_alias === "1",
      memberSetImage: group?.group_member_image === "1",
      memberSetVideo: group?.group_member_video === "1",
      memberSetDocument: group?.group_member_doc === "1",
      memberSetQuitMsg: group?.group_member_quit_msg === "1",
      memberSetJoinMsg: group?.join_notice === 1,
    });
  }, [visible, group]);

  useEffect(() => {
    if (visible) {
      Animated.timing(slideAnim, {
        toValue: 1,
        duration: 300,
        easing: Easing.out(Easing.cubic),
        useNativeDriver: false,
      }).start();
    } else {
      Animated.timing(slideAnim, {
        toValue: 0,
        duration: 300,
        easing: Easing.out(Easing.cubic),
        useNativeDriver: false,
      }).start();
    }
  }, [visible]);
  
  if (!visible) {
    return null;
  }

  //入群审核
  const handleJoinGroupSwitch = (newValue: boolean) => {
    const prev = group?.group_check_switch ?? "0";
    // 本地立即生效（UI/输入区权限同步）
    setState({ ...state, joinGroup: newValue });
    updateGroupLocal({ group_check_switch: newValue ? "1" : "0" });
    const body = {
      tid: topic.tid,
      group_check_switch: newValue ? "1" : "0",
    };
    handle(body).then((res: any) => {
      hideLoading();
      if (res.code !== 0) {
        // 回滚
        setState({ ...state, joinGroup: prev === "1" });
        updateGroupLocal({ group_check_switch: prev });
        showToast(res?.msg || "操作失败");
      }
    });
  };

  const handleLookGroupList = (newValue: boolean) => {
    const prev = group?.group_allow_member_list ?? "1";
    setState({ ...state, lookGroupList: newValue });
    updateGroupLocal({ group_allow_member_list: newValue ? "1" : "0" });
    const body = {
      tid: topic.tid,
      group_allow_member_list: newValue ? "1" : "0",
    };
    handle(body).then((res: any) => {
      hideLoading();
      if (res.code !== 0) {
        setState({ ...state, lookGroupList: prev === "1" });
        updateGroupLocal({ group_allow_member_list: prev });
        showToast(res?.msg || "操作失败");
      }
    });
  };

  const handleOpenUser = (newValue: boolean) => {
    const prev = group?.group_allow_member_visit ?? "1";
    setState({ ...state, openUser: newValue });
    updateGroupLocal({ group_allow_member_visit: newValue ? "1" : "0" });
    const body = {
      tid: topic.tid,
      group_allow_member_visit: newValue ? "1" : "0",
    };
    handle(body).then((res: any) => {
      hideLoading();
      if (res.code !== 0) {
        setState({ ...state, openUser: prev === "1" });
        updateGroupLocal({ group_allow_member_visit: prev });
        showToast(res?.msg || "操作失败");
      }
    });
  };
  const handleMemberSetAlias = (newValue: boolean) => {
    const prev = group?.group_member_alias ?? "1";
    setState({ ...state, memberSetAlias: newValue });
    updateGroupLocal({ group_member_alias: newValue ? "1" : "0" });
    const body = {
      tid: topic.tid,
      group_member_alias: newValue ? "1" : "0",
    };
    handle(body).then((res: any) => {
      hideLoading();
      if (res.code !== 0) {
        setState({ ...state, memberSetAlias: prev === "1" });
        updateGroupLocal({ group_member_alias: prev });
        showToast(res?.msg || "操作失败");
      }
    });
  };
  const handleMemberSetImage = (newValue: boolean) => {
    const prev = group?.group_member_image ?? "1";
    setState({ ...state, memberSetImage: newValue });
    updateGroupLocal({ group_member_image: newValue ? "1" : "0" });
    const body = {
      tid: topic.tid,
      group_member_image: newValue ? "1" : "0",
    };
    handle(body).then((res: any) => {
      hideLoading();
      if (res.code !== 0) {
        setState({ ...state, memberSetImage: prev === "1" });
        updateGroupLocal({ group_member_image: prev });
        showToast(res?.msg || "操作失败");
      }
    });
  };

  const handleMemberSetVideo = (newValue: boolean) => {
    const prev = group?.group_member_video ?? "1";
    setState({ ...state, memberSetVideo: newValue });
    updateGroupLocal({ group_member_video: newValue ? "1" : "0" });
    const body = {
      tid: topic.tid,
      group_member_video: newValue ? "1" : "0",
    };
    handle(body).then((res: any) => {
      hideLoading();
      if (res.code !== 0) {
        setState({ ...state, memberSetVideo: prev === "1" });
        updateGroupLocal({ group_member_video: prev });
        showToast(res?.msg || "操作失败");
      }
    });
  };

  const handleMemberSetDocument = async () => {
    const prev = group?.group_member_doc ?? "1";
    const newValue = !(state.memberSetDocument === true);
    setState({ ...state, memberSetDocument: newValue });
    updateGroupLocal({ group_member_doc: newValue ? "1" : "0" });
    const body = { tid: topic.tid, group_member_doc: newValue ? "1" : "0" };
    const res = await handle(body);
    hideLoading();
    if (res.code !== 0) {
      setState({ ...state, memberSetDocument: prev === "1" });
      updateGroupLocal({ group_member_doc: prev });
      showToast(res?.msg || "操作失败");
    }
  };

  const handleMemberSetQuitMsg = (newValue: boolean) => {
    const prev = group?.group_member_quit_msg ?? "1";
    setState({ ...state, memberSetQuitMsg: newValue });
    updateGroupLocal({ group_member_quit_msg: newValue ? "1" : "0" });
    const body = {
      tid: topic.tid,
      group_member_quit_msg: newValue ? "1" : "0",
    };
    handle(body).then((res: any) => {
      hideLoading();
      if (res.code !== 0) {
        setState({ ...state, memberSetQuitMsg: prev === "1" });
        updateGroupLocal({ group_member_quit_msg: prev });
        showToast(res?.msg || "操作失败");
      }
    });
  };

  const handleMemberSetJoinMsg = (newValue: boolean) => {
    const prev = group?.join_notice ?? 0;
    setState({ ...state, memberSetJoinMsg: newValue });
    updateGroupLocal({ join_notice: newValue ? 1 : 0 });
    const body = {
      tid: topic.tid,
      join_notice: newValue ? 1 : 0,
    };
    handle(body).then((res: any) => {
      hideLoading();
      if (res.code !== 0) {
        setState({ ...state, memberSetJoinMsg: prev === 1 });
        updateGroupLocal({ join_notice: prev });
        showToast(res?.msg || "操作失败");
      }
    });
  };

  const handleFriendInviteEnter = (newValue: boolean) => {
    const prev = group?.group_friend_invite_enter ?? "1";
    setState({ ...state, friendInviteEnter: newValue });
    updateGroupLocal({ group_friend_invite_enter: newValue ? "1" : "0" });
    const body = {
      tid: topic.tid,
      group_friend_invite_enter: newValue ? "1" : "0",
    };
    handle(body).then((res: any) => {
      hideLoading();
      if (res.code !== 0) {
        setState({ ...state, friendInviteEnter: prev === "1" });
        updateGroupLocal({ group_friend_invite_enter: prev });
        showToast(res?.msg || "操作失败");
      }
    });
  };

  const handleNoSpeaking = (newValue: boolean) => {
    const prev = group?.group_ban_chat ?? "0";
    setState({ ...state, jinYan: newValue });
    updateGroupLocal({ group_ban_chat: newValue ? "1" : "0" });
    const body = {
      tid: topic.tid,
      group_ban_chat: newValue ? "1" : "0",
    };
    handle(body).then((res: any) => {
      hideLoading();
      if (res.code !== 0) {
        setState({ ...state, jinYan: prev === "1" });
        updateGroupLocal({ group_ban_chat: prev });
        showToast(res?.msg || "操作失败");
      }
    });
  };
  const setSetSpeakTime = () => {
    navigation.navigate("SettingIntervalTime", {
      tid: topic.tid,
      curTime: group?.group_chat_interval_time ?? "",
    });
  };

  const handle = (body: any) => {
    showLoading();
    return postJson<any>(`/v1/sdk/group/profile/set`, { body });
  };

  return (
    <Animated.View
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: white,
        zIndex: 1000,
        opacity: visible ? 1 : 0,
        transform: [
          {
            translateX: slideAnim.interpolate({
              inputRange: [0, 1],
              outputRange: [Platform.OS === "web" ? 400 : 1000, 0],
            }),
          },
        ],
      }}
    >
      <SafeAreaView style={{ flex: 1, backgroundColor: white }}>
        {/* 群管理标题栏 - 只在群管理页面显示 */}
        <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", padding: 15, borderBottomWidth: 1, borderBottomColor: "#f0f0f0", backgroundColor: white }}>
          <Text style={{ fontSize: 18, fontWeight: "bold" }}>{Str_GroupManagement}</Text>
          <TouchableOpacity onPress={onClose} style={{ padding: 5 }}>
            <Text style={{ fontSize: 16, color: "#333" }}>关闭</Text>
          </TouchableOpacity>
        </View>
        <ScrollView style={{ flex: 1 }}>
          <CommonSetting
            style={{ marginTop: 18 }}
            itemOption={[
              {
                text: Str_AddAdmin,
                visible: group?.uid === currentUid,
                onClick: () => {
                  navigation.navigate("GroupHandleAdmin", {
                    isAddAdmin: true,
                  });
                },
              },
              {
                text: Str_RemoveAdmin,
                visible: group?.uid === currentUid,
                onClick: () => {
                  navigation.navigate("GroupHandleAdmin", {
                    isAddAdmin: false,
                  });
                },
              },
            ]}
          />

          <CommonSetting
            style={{ marginTop: 12 }}
            itemOption={[
              {
                text: Str_MemberModifyGroupNickname,
                rightType: "Switch",
                switchIsEnabled: state.memberSetAlias,
                setIsEnabled: (enabled) =>
                  setState({ ...state, memberSetAlias: enabled }),
                switchChange: handleMemberSetAlias,
              },

              {
                text: Str_MemberSendImage,
                rightType: "Switch",
                switchIsEnabled: state.memberSetImage,
                setIsEnabled: (enabled) =>
                  setState({ ...state, memberSetImage: enabled }),
                switchChange: handleMemberSetImage,
              },
              {
                text: Str_MemberSendVideo,
                rightType: "Switch",
                switchIsEnabled: state.memberSetVideo,
                setIsEnabled: (enabled) =>
                  setState({ ...state, memberSetVideo: enabled }),
                switchChange: handleMemberSetVideo,
              },
              // {
              //   text: Str_MemberSendDocument, rightType: "Switch",
              //   switchIsEnabled: state.memberSetDocument,
              //   setIsEnabled: (enabled) => setState({ ...state, memberSetDocument: enabled }),
              //   switchChange: handleMemberSetDocument
              // },
              {
                text: Str_MemberJoinGroupMessage,
                rightType: "Switch",
                switchIsEnabled: state.memberSetJoinMsg,
                setIsEnabled: (enabled) => setState({ ...state, memberSetJoinMsg: enabled }),
                switchChange: handleMemberSetJoinMsg
              },
              {
                text: Str_MemberLeaveGroupMessage,
                rightType: "Switch",
                switchIsEnabled: state.memberSetQuitMsg,
                setIsEnabled: (enabled) => setState({ ...state, memberSetQuitMsg: enabled }),
                switchChange: handleMemberSetQuitMsg,
              },
              {
                text: Str_SetFontStyle,
                rightType: "Back",
                onClick: () => {
                  navigation.push("GroupChatFontSetting", {
                    tid: group?.tid ?? "",
                  });
                },
              },
            ]}
          />

          <CommonSetting
            style={{ marginTop: 12 }}
            itemOption={[
              {
                text: Str_GroupEntryReview,
                rightType: "Switch",
                switchIsEnabled: state.joinGroup,
                setIsEnabled: (enabled) =>
                  setState({ ...state, joinGroup: enabled }),
                switchChange: handleJoinGroupSwitch,
              },
              {
                text: Str_FriendInviteEnter,
                rightType: "Switch",
                switchIsEnabled: state.friendInviteEnter,
                setIsEnabled: (enabled) =>
                  setState({ ...state, friendInviteEnter: enabled }),
                switchChange: handleFriendInviteEnter,
              },
              // {
              //     text: Str_LookGroupList, rightType: "Switch",
              //     switchIsEnabled: state.lookGroupList,
              //     setIsEnabled: (enabled) => setState({ ...state, lookGroupList: enabled }),
              //     switchChange: handleLookGroupList
              // },
              {
                text: Str_OpenUser,
                rightType: "Switch",
                switchIsEnabled: state.openUser,
                setIsEnabled: (enabled) =>
                  setState({ ...state, openUser: enabled }),
                switchChange: handleOpenUser,
              },
            ]}
          />
          <CommonSetting
            style={{ marginTop: 12 }}
            itemOption={[
              {
                text: Str_AllProhibition,
                subText: `（${Str_AllProhibitionTip}）`,
                switchIsEnabled: state.jinYan,
                rightType: "Switch",
                setIsEnabled: (enabled) =>
                  setState({ ...state, jinYan: enabled }),
                switchChange: handleNoSpeaking,
              },
              {
                text: Str_Prohibition,
                onClick: () => {
                  navigation.navigate("GroupBlackAddOrRemove", {
                    isRemove: false,
                  });
                },
              },
              {
                text: Str_RemoveProhibition,
                onClick: () => {
                  navigation.navigate("GroupBlackAddOrRemove", {
                    isRemove: true,
                  });
                },
              },
              {
                text: Str_GroupChatIntervalTime,
                onClick: () => setSetSpeakTime(),
                rightText:
                  group?.group_chat_interval_time &&
                  group.group_chat_interval_time.length > 0 &&
                  group?.group_chat_interval_time !== "0"
                    ? `${group?.group_chat_interval_time}${Str_Second}`
                    : "",
              },
            ]}
          />
          <CommonSetting
            style={{ marginVertical: 12 }}
            itemOption={[
              {
                visible: group?.uid == currentUid,
                text: Str_TransferGroup,
                onClick: () => {
                  if (group?.flag === 2) {
                    showToast(Str_GroupDisbanded);
                  } else {
                    navigation.navigate("GroupTransferUser");
                  }
                },
              },
            ]}
          />
        </ScrollView>
      </SafeAreaView>
    </Animated.View>
  );
};

// 保留原来的组件以保持兼容性
export const GroupManager = ({ navigation }: MainNavProps<"GroupManager">) => {
  const [visible, setVisible] = useState(true);

  return (
    <View style={{ flex: 1, backgroundColor: white }}>
      <GroupManagerModal
        visible={visible}
        onClose={() => {
          setVisible(false);
          navigation.goBack();
        }}
        navigation={navigation}
      />
    </View>
  );
};
